import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Typography, Button, Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import "./DemoHome.css";

import koopakteImg from "../../img/module-housing-buy.jpg";
import huurImg from "../../img/module-housing-rent.jpg";
import gymImg from "../../img/module-leisure-gym.jpg";

const HouseIcon = ({ color }) => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 640 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M125.2 16.1C131.4 11.7 130.6 1.3 123 0.5C119.4 0.1 115.7 0 112 0C50.1 0 0 50.1 0 112C0 173.9 50.1 224 112 224C144.1 224 173.1 210.5 193.5 188.8C198.7 183.2 192.5 174.8 184.9 175.6C182 175.9 179 176 175.9 176C127.3 176 87.9 136.6 87.9 88C87.9 58.3 102.6 32.1 125.1 16.1H125.2ZM415.1 101.4C406.3 94.2 393.6 94.2 384.8 101.4L168.8 277.4C158.5 285.8 157 300.9 165.4 311.2C173.8 321.5 188.9 323 199.2 314.6L224 294.4V456C224 486.9 249.1 512 280 512H520C550.9 512 576 486.9 576 456V294.4L600.8 314.6C611.1 323 626.2 321.4 634.6 311.2C643 301 641.4 285.8 631.2 277.4L415.2 101.4H415.1ZM528 255.3V456C528 460.4 524.4 464 520 464H280C275.6 464 272 460.4 272 456V255.3L400 151L528 255.3ZM352 312V360C352 373.3 362.7 384 376 384H424C437.3 384 448 373.3 448 360V312C448 298.7 437.3 288 424 288H376C362.7 288 352 298.7 352 312ZM248.5 12.3L236.6 44.6L204.3 56.5C197.3 59.1 197.3 68.9 204.3 71.5L236.6 83.4L248.5 115.7C251.1 122.7 260.9 122.7 263.5 115.7L275.4 83.4L307.7 71.5C314.7 68.9 314.7 59.1 307.7 56.5L275.4 44.6L263.5 12.3C260.9 5.3 251.1 5.3 248.5 12.3ZM103.5 332.3C100.9 325.3 91.1 325.3 88.5 332.3L76.6 364.6L44.3 376.5C37.3 379.1 37.3 388.9 44.3 391.5L76.6 403.4L88.5 435.7C91.1 442.7 100.9 442.7 103.5 435.7L115.4 403.4L147.7 391.5C154.7 388.9 154.7 379.1 147.7 376.5L115.4 364.6L103.5 332.3Z"
        fill={color}
      />
    </svg>
  );
};

const CareerIcon = ({ color }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 448 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M224 208C245.217 208 265.566 199.571 280.569 184.569C295.571 169.566 304 149.217 304 128C304 106.783 295.571 86.4344 280.569 71.4315C265.566 56.4285 245.217 48 224 48C202.783 48 182.434 56.4285 167.431 71.4315C152.429 86.4344 144 106.783 144 128C144 149.217 152.429 169.566 167.431 184.569C182.434 199.571 202.783 208 224 208ZM352 128C352 161.948 338.514 194.505 314.51 218.51C290.505 242.514 257.948 256 224 256C190.052 256 157.495 242.514 133.49 218.51C109.486 194.505 96 161.948 96 128C96 94.0523 109.486 61.495 133.49 37.4903C157.495 13.4857 190.052 0 224 0C257.948 0 290.505 13.4857 314.51 37.4903C338.514 61.495 352 94.0523 352 128ZM209.1 359.2L190.5 328.2C184.1 317.5 191.8 304 204.2 304H223.9H243.6C256 304 263.7 317.6 257.3 328.2L238.7 359.2L254.6 418.4L298.4 330.8C301.4 324.8 307.8 321.3 314.3 322.4C390.4 335.6 448 401.7 448 481.3C448 498.3 434.2 512 417.3 512H30.7C13.8 512 0 498.2 0 481.3C0 401.7 57.6 335.6 133.5 322.4C140.1 321.3 146.4 324.8 149.4 330.8L193.2 418.4L209.1 359.2ZM118.5 376.3C82.3 391.1 55.4 424.2 49.3 464H162.3L118.5 376.3ZM285.7 464H398.7C392.6 424.2 365.7 391.1 329.5 376.3L285.7 464Z"
        fill={color}
      />
    </svg>
  );
};

const LeisureIcon = ({ color }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M412.4 99.5001C464.6 151.7 477.2 228.5 450.1 292.6C465.9 297 480.5 304.3 493.2 313.9C529.1 231.9 513.5 132.7 446.4 65.6001C358.9 -21.8999 217.1 -21.8999 129.6 65.6001L69.5 125.7C45.5 149.7 32 182.3 32 216.2V218.9C32 252.8 45.5 285.4 69.5 309.4C82.9 322.8 81.5 345 66.5 356.6L17.2 394.6C6.3 403.1 0 416 0 429.7C0 441.4 4.7 452.6 12.9 460.9L51 499C59.3 507.3 70.5 511.9 82.2 511.9C95.9 511.9 108.8 505.6 117.2 494.7L155.2 445.4C166.8 430.4 189 428.9 202.4 442.4C226.4 466.4 259 479.9 292.9 479.9H295.6C298.7 479.9 301.7 479.8 304.8 479.6C296.5 465.2 291 449 288.8 431.8C269.1 430.8 250.3 422.5 236.3 408.5C202.4 374.6 146.4 378.2 117.1 416.2L81.9 462L49.9 430L95.7 394.7C133.7 365.4 137.3 309.4 103.4 275.5C88.4 260.5 80 240.2 80 219V216.3C80 205.3 82.3 194.5 86.6 184.6L290.9 388.8C294.6 371.6 301.8 355.6 311.7 341.7L116.5 146.6L163.5 99.6001C232.2 30.9001 343.7 30.9001 412.4 99.6001V99.5001ZM368 416C368 403.27 373.057 391.061 382.059 382.059C391.061 373.057 403.27 368 416 368C428.73 368 440.939 373.057 449.941 382.059C458.943 391.061 464 403.27 464 416C464 428.73 458.943 440.939 449.941 449.941C440.939 458.943 428.73 464 416 464C403.27 464 391.061 458.943 382.059 449.941C373.057 440.939 368 428.73 368 416ZM512 416C512 390.539 501.886 366.121 483.882 348.118C465.879 330.114 441.461 320 416 320C390.539 320 366.121 330.114 348.118 348.118C330.114 366.121 320 390.539 320 416C320 441.461 330.114 465.879 348.118 483.882C366.121 501.886 390.539 512 416 512C441.461 512 465.879 501.886 483.882 483.882C501.886 465.879 512 441.461 512 416Z"
        fill={color}
      />
    </svg>
  );
};

const DemoHome = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const categories = [
    { key: "wonen", label: t("demoHome.categories.wonen") },
    { key: "sport", label: t("demoHome.categories.sport") },
    { key: "werk", label: t("demoHome.categories.werk") },
  ];

  const modules = [
    {
      categoryKey: "wonen",
      title: t("demoHome.modules.koopakte.title"),
      description: t("demoHome.modules.koopakte.description"),
      path: "/koopakte",
      image: koopakteImg,
    },
    {
      categoryKey: "wonen",
      title: t("demoHome.modules.huur.title"),
      description: t("demoHome.modules.huur.description"),
      path: "/huurovereenkomst",
      image: huurImg,
    },
    {
      categoryKey: "sport",
      title: t("demoHome.modules.gym.title"),
      description: t("demoHome.modules.gym.description"),
      path: "/sportschool",
      image: gymImg,
      comingSoon: true,
    },
  ];

  const [activeCategory, setActiveCategory] = useState("wonen");

  const filtered = modules.filter((m) => m.categoryKey === activeCategory);
  const activeCategoryLabel = categories.find((c) => c.key === activeCategory)?.label;

  return (
    <div className="demo-home">
      <Typography className="demo-home-title">{t("demoHome.title")}</Typography>

      {/* Categorie-filters */}
      <div className="demo-home-filters">
        {categories.map((cat) => (
          <Chip
            key={cat.key}
            icon={
              cat.key === "wonen"
                ? <HouseIcon color={activeCategory === cat.key ? "#ffffff" : "#454545"} />
                : cat.key === "sport"
                ? <LeisureIcon color={activeCategory === cat.key ? "#ffffff" : "#454545"} />
                : <CareerIcon color={activeCategory === cat.key ? "#ffffff" : "#454545"} />
            }
            label={cat.label}
            onClick={() => setActiveCategory(cat.key)}
            className={`demo-chip ${
              activeCategory === cat.key ? "demo-chip-active" : ""
            }`}
          />
        ))}
      </div>

      {/* Kaarten */}
      <div className="demo-cards-grid">
        {filtered.length > 0 ? (
          filtered.map((mod) => (
            <div key={mod.path} className="demo-card">
              <div
                className="demo-card-image"
                style={{ backgroundImage: `url(${mod.image})` }}
              />
              <div className="demo-card-body">
                <div className="demo-card-category">
                  {mod.categoryKey === "wonen" ? (
                    <HouseIcon color="#454545" />
                  ) : (
                    <LeisureIcon color="#454545" />
                  )}
                  <span>{activeCategoryLabel}</span>
                </div>
                <Typography className="demo-card-title">{mod.title}</Typography>
                <Typography className="demo-card-description">
                  {mod.description}
                </Typography>
                <div className="demo-card-footer">
                  <span
                    className="demo-card-link"
                    onClick={() => navigate(mod.path)}
                  >
                    {t("demoHome.readMore")}
                  </span>
                  <Button
                    variant="contained"
                    className="demo-card-btn"
                    onClick={() => !mod.comingSoon && navigate(mod.path)}
                    disabled={mod.comingSoon}
                  >
                    {mod.comingSoon ? t("demoHome.comingSoon") : t("demoHome.doCheck")}
                  </Button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <Typography sx={{ color: "#454545", mt: 2 }}>
            {t("demoHome.noModules")}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default DemoHome;
